import React from 'react';
import Grid from '../../common/Grid/Grid';
import EmployeeCardItem from './EmployeeCardItem';

const EmployeeGrid = ({
  employees,
  isLoading,
  isLoadingMore,
  pageInfo,
  handleItemClick,
  handleGridScroll,
  showLoadingSpinner,
  shouldHideContent,
  loadMoreData,
  gridRef,
  onEdit,
  onView,
  onResign,
  onMarkNoShow,
  onHireWithdraw,
  onRehire,
  onManageContract,
}) => {
  // Custom renderer for Employee items. ADR-113 §5: the card menu is a
  // launcher — the end-date/renewal verbs moved to the Contracts tab
  // (onManageContract routes there); only the person verbs and the
  // retained shortcuts keep card callbacks.
  const renderEmployeeItem = ({ item, onClick }) => {
    return <EmployeeCardItem
      employee={item}
      onClick={onClick}
      onEdit={onEdit}
      onView={onView}
      onResign={onResign}
      onMarkNoShow={onMarkNoShow}
      onHireWithdraw={onHireWithdraw}
      onRehire={onRehire}
      onManageContract={onManageContract}
    />;
  };

  return (
    <Grid
      items={employees}
      isLoading={isLoading}
      isLoadingMore={isLoadingMore}
      pageInfo={pageInfo}
      renderItem={renderEmployeeItem}
      handleItemClick={handleItemClick}
      handleGridScroll={handleGridScroll}
      showLoadingSpinner={showLoadingSpinner}
      shouldHideContent={shouldHideContent}
      loadMoreData={loadMoreData}
      gridRef={gridRef}
      rowHeight={450}
      emptyStateTitle="No Individuals Found"
      emptyStateDescription="No individuals found matching the current filters. Try adjusting your search criteria or filters."
      endOfListMessage="You've reached the end of the list"
    />
  );
};

export default EmployeeGrid;